export enum StatusId {
  ACTIVE = 1,
  INACTIVE = 2,
}
